var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "checkbox-item",
    class: {
      checked: _vm.checked
    },
    on: {
      "click": _vm.onToggle
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('input', {
    staticClass: "native-checkbox",
    attrs: {
      "type": "checkbox",
      "id": _vm.id
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": function change($event) {
        $event.stopPropagation();
        return _vm.onToggle.apply(null, arguments);
      }
    }
  }), _c('span', {
    staticClass: "fake-box",
    class: {
      checked: _vm.checked
    }
  })]), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))])]), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "right-display"
  }, [_vm._v(_vm._s(_vm.rightDisplayInfo))]), _c('button', {
    staticClass: "info-toggle",
    style: {
      visibility: _vm.expandable && _vm.hasDetails ? 'visible' : 'hidden'
    },
    attrs: {
      "type": "button",
      "aria-expanded": _vm.checked
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('toggle');
      }
    }
  }, [_c('span', {
    staticClass: "caret",
    class: {
      open: _vm.checked
    }
  })])]), _vm.expandable && _vm.checked || !_vm.expandable && _vm.hasDetails ? _c('div', {
    staticClass: "info-row"
  }, [_vm.expandable ? _c('transition', {
    attrs: {
      "name": "fade-slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.checked,
      expression: "checked"
    }],
    staticClass: "info",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("details", null, {
    "details": _vm.detailedInfo
  })], 2)]) : _vm.hasDetails ? _c('div', {
    staticClass: "info",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("details", null, {
    "details": _vm.detailedInfo
  })], 2) : _vm._e()], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }